import { Tense } from '../types';

export const tenses: Tense[] = [
  { 
    id: 'present', 
    name: 'présent', 
    display: 'Le Présent (Present)' 
  },
  { 
    id: 'imparfait', 
    name: 'imparfait', 
    display: 'L\'Imparfait (Imperfect)' 
  },
  { 
    id: 'futur_simple', 
    name: 'futur simple', 
    display: 'Le Futur Simple (Simple Future)' 
  },
  { 
    id: 'passe_compose', 
    name: 'passé composé', 
    display: 'Le Passé Composé (Perfect Tense)' 
  },
  { 
    id: 'conditionnel_present', 
    name: 'conditionnel présent', 
    display: 'Le Conditionnel Présent (Conditional)' 
  },
  { 
    id: 'subjonctif_present', 
    name: 'subjonctif présent', 
    display: 'Le Subjonctif Présent (Subjunctive)' 
  }
];
